__turbopack_context__.v({
  "wrapper": "PresenterInfo-module-scss-module__8cihGW__wrapper",
});
